import { setSettingsPage } from "../../actions/session";
import Icon from "../../controls/Icon";
import Spinner from "../../controls/Spinner";
import * as selectors from "../../util/selectors";
import { setProfilesVisible } from "../settings_interface/actions/interface";
import * as React from "react";
import * as winapi from "winapi-bindings";
const ONE_GB = 1024 * 1024 * 1024;
const MIN_DISK_SPACE = 200 * ONE_GB;
const freeSpace = {};
function minDiskSpace(required, key) {
    return (props) => {
        const checkPath = props[key];
        if (checkPath === undefined) {
            return false;
        }
        if (freeSpace[key] === undefined || freeSpace[key].path !== checkPath) {
            try {
                freeSpace[key] = {
                    path: checkPath,
                    free: winapi.GetDiskFreeSpaceEx(checkPath).freeToCaller,
                };
            }
            catch (err) {
                return false;
            }
        }
        return freeSpace[key].free < required;
    };
}
function todos(api) {
    const onSetSettingsPage = (pageId) => {
        api.store.dispatch(setSettingsPage(pageId));
    };
    const openSettingsPage = (page) => {
        api.events.emit("show-main-page", "application_settings");
        onSetSettingsPage(page);
    };
    const startManualSearch = () => {
        api.events.emit("start-discovery");
    };
    const openGames = () => {
        api.events.emit("show-main-page", "Games");
    };
    return [
        {
            id: "pick-game",
            icon: "game",
            type: "search",
            priority: 10,
            props: (state) => ({ gameMode: selectors.activeGameId(state) }),
            condition: (props) => props.gameMode === undefined,
            text: "Select a game to manage",
            action: openGames,
        },
        {
            id: "profile-visibility",
            icon: "profile",
            type: "settings",
            priority: 20,
            props: (state) => ({
                profilesVisible: state.settings.interface.profilesVisible,
            }),
            text: "Profile Management",
            value: (t, props) => props.profilesVisible ? t("Yes") : t("No"),
            action: (props) => {
                api.store.dispatch(setProfilesVisible(!props.profilesVisible));
                api.events.emit("analytics-track-click-event", "Dashboard", `Profile management ${!props.profilesVisible ? "ON" : "OFF"}`);
            },
        },
        {
            id: "download-location",
            icon: "settings",
            type: "settings",
            priority: 30,
            props: (state) => ({ dlPath: selectors.downloadPath(state) }),
            text: "Downloads are on drive",
            value: (t, props) => {
                try {
                    return winapi.GetVolumePathName(props.dlPath);
                }
                catch (err) {
                    err["dlPath"] = props.dlPath;
                    throw err;
                }
            },
            action: () => {
                openSettingsPage("Download");
                api.events.emit("analytics-track-click-event", "Dashboard", "Download drive");
                api.highlightControl("#settings-tab-pane-Download #download-path-form", 5000, api.translate("You can change the download location here"));
            },
            condition: minDiskSpace(MIN_DISK_SPACE, "dlPath"),
        },
        {
            id: "mod-location",
            icon: "settings",
            type: "settings",
            priority: 31,
            props: (state) => ({ instPath: selectors.installPath(state) }),
            text: "Mods are staged on drive",
            value: (t, props) => {
                try {
                    if (props.instPath === undefined) {
                        return t("<No staging folder>");
                    }
                    return winapi.GetVolumePathName(props.instPath);
                }
                catch (err) {
                    return t("<Invalid Drive>");
                }
            },
            action: () => {
                openSettingsPage("Mods");
                api.events.emit("analytics-track-click-event", "Dashboard", "Staged drive");
                api.highlightControl("#settings-tab-pane-Mods #install-path-form", 5000, api.translate("You can change the mod staging location here"));
            },
            condition: minDiskSpace(MIN_DISK_SPACE, "instPath"),
        },
        {
            id: "manual-scan",
            icon: (props) => props.discoveryRunning ? React.createElement(Spinner, null) : React.createElement(Icon, { name: "search" }),
            type: "search",
            priority: 40,
            props: (state) => ({
                discoveryRunning: state.session.discovery.running,
            }),
            condition: (props) => props.searchPaths !== undefined,
            text: (t, props) => props.discoveryRunning
                ? t("Discovery running")
                : t("Scan for missing games"),
            action: startManualSearch,
        },
    ];
}
export default todos;
